import { render, staticRenderFns } from "./language_translation.vue?vue&type=template&id=7a63cfa0&scoped=true"
import script from "./language_translation.vue?vue&type=script&lang=js"
export * from "./language_translation.vue?vue&type=script&lang=js"
import style0 from "./language_translation.vue?vue&type=style&index=0&id=7a63cfa0&prod&scoped=true&lang=css"
import style1 from "./language_translation.vue?vue&type=style&index=1&id=7a63cfa0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a63cfa0",
  null
  
)

export default component.exports